import { Check, Minus } from "lucide-react";
import { Eyebrow, GoldLine, Reveal, WhatsAppButton } from "@/components/bits";

/* ---------------------------- 12. PER CHI È ---------------------------- */
const perChiItems = [
  "senti che alcune ferite del passato continuano a influenzare il presente",
  "fai fatica a gestire determinate emozioni",
  "vivi spesso nella paura di perdere persone o situazioni",
  "senti un forte bisogno di controllo",
  "fai fatica a mettere confini",
  "cerchi continuamente approvazione",
  "vuoi migliorare la tua relazione",
  "vuoi lavorare sul tuo matrimonio",
  "vuoi essere una madre più presente e meno sopraffatta",
  "vuoi ricostruire disciplina e abitudini",
  "vuoi prenderti nuovamente cura del tuo corpo",
  "vuoi comprendere meglio la tua identità",
  "vuoi smettere di vivere costantemente in reazione",
  "vuoi mettere realmente Dio al centro della tua vita",
  "senti che è arrivato il momento di prenderti responsabilità della donna che stai diventando",
];

export const PerChi = () => (
  <section data-testid="per-chi-section" className="bg-[#F4EFE6]">
    <div className="mx-auto max-w-5xl px-6 py-24 md:px-10 md:py-36">
      <Reveal>
        <h2 className="font-serif text-3xl leading-tight tracking-tight text-[#1A1818] md:text-5xl">
          Questo percorso può essere per te se…
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <GoldLine className="mt-10" />
      </Reveal>
      <div className="mt-12 grid grid-cols-1 gap-x-12 md:grid-cols-2">
        {perChiItems.map((item, i) => (
          <Reveal key={item} delay={0.03 * (i % 8)}>
            <p className="flex items-start gap-4 border-b border-[#2A2421]/10 py-4 text-base text-[#3A3532]">
              <Check className="mt-1 h-4 w-4 shrink-0 text-[#A98A2C]" strokeWidth={2} />
              {item}
            </p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1}>
        <p className="mt-14 text-base leading-relaxed text-[#3A3532] md:text-lg">
          Che tu sia single, fidanzata, sposata, madre, separata o in una fase completamente nuova
          della tua vita:
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-6 font-serif text-3xl uppercase leading-snug tracking-[0.04em] text-[#1A1818] md:text-4xl">
          Il tuo stato relazionale non definisce il tuo valore.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-6 font-serif text-xl italic text-[#3A3532] md:text-2xl">
          Il punto di partenza sei tu.
        </p>
      </Reveal>
    </div>
  </section>
);

/* ---------------------- 13. NON DEVI AVERE GIÀ TUTTO CHIARO ---------------------- */
export const Conversione = () => (
  <section data-testid="conversione-section">
    <div className="mx-auto max-w-3xl px-6 py-24 text-center md:px-10 md:py-36">
      <Reveal>
        <h2 className="font-serif text-3xl leading-tight tracking-tight text-[#1A1818] md:text-5xl">
          Non devi avere già tutte le risposte.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mx-auto mt-8 max-w-xl space-y-2 text-base leading-relaxed text-[#3A3532] md:text-lg">
          <p>Se leggendo questa pagina hai riconosciuto una parte di te, puoi semplicemente scrivermi.</p>
          <p>Non serve preparare un discorso perfetto.</p>
          <p>Non serve sapere già quale sia il problema esatto.</p>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-8 text-base text-[#3A3532] md:text-lg">Puoi iniziare scrivendo:</p>
      </Reveal>
      <Reveal delay={0.2}>
        <blockquote className="mx-auto mt-6 max-w-xl border border-[#D4AF37]/40 bg-[#F4EFE6] p-8" data-testid="conversione-message">
          <p className="font-serif text-lg italic leading-snug text-[#1A1818] md:text-xl">
            “Ciao Chiara, ho letto di Donna Virtuosa e vorrei capire se può fare per me.”
          </p>
        </blockquote>
      </Reveal>
      <Reveal delay={0.25}>
        <p className="mt-8 text-base text-[#3A3532] md:text-lg">Da lì iniziamo a conoscerci.</p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-10">
          <WhatsAppButton label="Parla con Chiara" testid="conversione-whatsapp-cta" />
        </div>
      </Reveal>
    </div>
  </section>
);

/* ---------------------------- 14. PER CHI NON È ---------------------------- */
const nonPerItems = [
  "prenda decisioni al posto tuo",
  "ti dica semplicemente quello che vuoi sentirti dire",
  "attribuisca sempre agli altri la responsabilità di ciò che vivi",
  "prometta una trasformazione senza lavoro personale",
  "sostituisca uno psicologo o un professionista sanitario",
  "diventi la tua guida religiosa",
  "risolva magicamente matrimonio, relazioni o vita personale",
];

const richiede = ["Onestà.", "Responsabilità.", "Apertura.", "Disciplina.", "Disponibilità a mettersi in discussione."];

export const NonPer = () => (
  <section data-testid="non-per-section" className="bg-[#1A1818] text-[#FDFBF7]">
    <div className="mx-auto max-w-4xl px-6 py-24 md:px-10 md:py-36">
      <Reveal>
        <h2 className="font-serif text-3xl leading-tight tracking-tight md:text-5xl">
          Donna Virtuosa non è per tutte.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-8 text-base leading-relaxed text-[#FDFBF7]/75 md:text-lg">
          Questo percorso probabilmente non è adatto a te se stai cercando qualcuno che:
        </p>
      </Reveal>
      <div className="mt-8">
        {nonPerItems.map((item, i) => (
          <Reveal key={item} delay={0.04 * i}>
            <p className="flex items-start gap-4 border-b border-[#FDFBF7]/10 py-4 text-base text-[#FDFBF7]/75">
              <Minus className="mt-1.5 h-4 w-4 shrink-0 text-[#D4AF37]" strokeWidth={2} />
              {item}
            </p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1}>
        <p className="mt-14 text-xs font-semibold uppercase tracking-[0.28em] text-[#D4AF37]">
          Donna Virtuosa richiede
        </p>
      </Reveal>
      <div className="mt-6 space-y-1">
        {richiede.map((r, i) => (
          <Reveal key={r} delay={0.06 * i}>
            <p className="font-serif text-2xl uppercase leading-snug tracking-[0.05em] md:text-3xl">{r}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

/* ---------------------------- 15. COME FUNZIONA ---------------------------- */
const steps = [
  { num: "01", title: "Mi scrivi", text: "Clicchi sul pulsante WhatsApp e mi racconti brevemente cosa stai vivendo." },
  { num: "02", title: "Primo confronto conoscitivo", text: "Ti farò alcune domande per comprendere meglio la tua situazione, ciò su cui vuoi lavorare e cosa stai cercando." },
  { num: "03", title: "Definiamo gli obiettivi", text: "Non tutte hanno bisogno dello stesso tipo di supporto. Valutiamo insieme se Donna Virtuosa è coerente con ciò che stai vivendo e definiamo gli obiettivi su cui lavorare." },
  { num: "04", title: "Incontri individuali di coaching", text: "Se decidiamo di lavorare insieme, inizieremo il percorso individuale: incontri di coaching one to one costruiti sulla tua storia e sui tuoi obiettivi." },
  { num: "05", title: "Applicazione nella vita quotidiana", text: "Incontro dopo incontro lavoreremo affinché ciò che comprendi diventi qualcosa che inizi concretamente ad applicare nella tua quotidianità." },
];

export const ComeFunziona = () => (
  <section id="percorso" data-testid="come-funziona-section" className="scroll-mt-24">
    <div className="mx-auto max-w-5xl px-6 py-24 md:px-10 md:py-36">
      <Reveal>
        <Eyebrow>Passo dopo passo</Eyebrow>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-serif text-3xl leading-tight tracking-tight text-[#1A1818] md:text-5xl">
          Come funziona
        </h2>
      </Reveal>
      <div className="relative mt-16">
        <div className="absolute bottom-0 left-[19px] top-0 w-px bg-[#D4AF37]/40 md:left-[23px]" aria-hidden="true" />
        <div className="space-y-14">
          {steps.map((step, i) => (
            <Reveal key={step.num} delay={0.05 * i}>
              <div className="relative flex gap-8 md:gap-12" data-testid={`step-${step.num}`}>
                <div className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center border border-[#D4AF37] bg-[#FDFBF7] md:h-12 md:w-12">
                  <span className="font-serif text-sm text-[#A98A2C] md:text-base">{step.num}</span>
                </div>
                <div className="pb-2">
                  <h3 className="font-serif text-2xl uppercase tracking-[0.08em] text-[#1A1818] md:text-3xl">
                    {step.title}
                  </h3>
                  <p className="mt-3 max-w-xl text-base leading-relaxed text-[#3A3532]">{step.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal delay={0.1}>
        <div className="mt-16 max-w-3xl border-l-2 border-[#D4AF37] pl-6">
          <p className="text-base leading-relaxed text-[#3A3532] md:text-lg">
            L&rsquo;obiettivo non è renderti dipendente dal coaching.
          </p>
          <p className="mt-2 font-serif text-xl italic leading-snug text-[#1A1818] md:text-2xl">
            L&rsquo;obiettivo è aiutarti a diventare più consapevole, responsabile e capace di
            governare ciò che ti è stato affidato.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

/* --------------------- 16. SU COSA POTREMMO LAVORARE --------------------- */
const lavoroItems = [
  "comprendere meglio ciò che senti",
  "individuare alcuni schemi ricorrenti",
  "riconoscere convinzioni limitanti",
  "migliorare la comunicazione",
  "costruire confini più sani",
  "sviluppare nuove abitudini",
  "aumentare la consapevolezza personale",
  "migliorare la gestione del tempo",
  "essere più intenzionale nelle relazioni",
  "prenderti cura del corpo con maggiore equilibrio",
  "lavorare sul rapporto con il passato",
  "sviluppare maggiore responsabilità personale",
  "vivere la fede in maniera più concreta nella quotidianità",
  "costruire maggiore disciplina",
  "imparare a fermarti prima di reagire",
  "prendere decisioni più consapevoli",
];

export const LavoroInsieme = () => (
  <section data-testid="lavoro-section" className="bg-[#F4EFE6]">
    <div className="mx-auto max-w-5xl px-6 py-24 md:px-10 md:py-36">
      <Reveal>
        <h2 className="font-serif text-3xl leading-tight tracking-tight text-[#1A1818] md:text-5xl">
          Su cosa potremmo lavorare insieme
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#3A3532] md:text-lg">
          Ogni donna parte da una storia diversa e nessun risultato può essere garantito.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#3A3532] md:text-lg">
          Durante Donna Virtuosa potrai lavorare per:
        </p>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-x-12 md:grid-cols-2">
        {lavoroItems.map((item, i) => (
          <Reveal key={item} delay={0.03 * (i % 8)}>
            <p className="flex items-start gap-4 border-b border-[#2A2421]/10 py-3.5 text-base text-[#3A3532]">
              <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-[#D4AF37]" aria-hidden="true" />
              {item}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
